// 首筆主幣流入 - 繁體中文
export default {
  title: "首筆主幣流入",
  loading: { text: "拼命加載中" },
  fields: {
    address: "地址",
    txHash: "交易hash",
    quantity: "交易數量",
    txTime: "交易時間",
  },
  copy: "複製",
  none: "--",
};
